import React, { useState, useContext, useEffect } from 'react';
import { BiChevronUp } from 'react-icons/bi';
import { FaCheck } from 'react-icons/fa';
import { ClubFittingContext } from "../../ClubfittingNew/ClubFittingContext";
import { FaArrowsAltV, FaArrowsAltH } from "react-icons/fa";
import StickSvg from '../Clubfitting SvgData/StickSvg';
import { Form } from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';

const IronsData = ({ step, iron, title, options, number, shotOpction, shortStrike, options2 }) => {
    const { remotefittingdata, setRemotefittingdata, updateremotefitting } = useContext(ClubFittingContext);

    const [selectedNUmberX, setSelectedNUmberX] = useState(0);
    const [selectedNUmberY, setSelectedNUmberY] = useState(0);


    const [dropdownState, setDropdownState] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });

    const [dropdownState2, setDropdownState2] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });

    const [dropdownState3, setDropdownState3] = useState({
        isOpen1: false,
        isOpen2: false,
        isOpen3: false,
        isOpenx: false,
        isOpeny: false
    });


    const handleToggleDropdown = (dropdownName) => {
        setDropdownState((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    };

    const handleToggleDropdown2 = (dropdownName) => {
        setDropdownState2((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    };

    const handleToggleDropdown3 = (dropdownName) => {
        setDropdownState3((prevState) => ({
            ...prevState,
            [dropdownName]: !prevState[dropdownName],
        }));
    }


    const handleOptionClick1 = (option, path) => {
        updateremotefitting(path, option.text);
    };

    const handleOptionClickResult = (option, path) => {
        updateremotefitting(path, option.text);
    }

    useEffect(() => {
        // set all dropedown to false
        console.log("remotefittingdataaminesh", remotefittingdata);
        setDropdownState({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false
        });

        setDropdownState2({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false
        });

        setDropdownState3({
            isOpen1: false,
            isOpen2: false,
            isOpen3: false
        });
    }, [remotefittingdata])


    const handleOptionStrickY = (option, shotoption, shot) => {
        const newOption = { ...option, shot: shot };
        setSelectedNUmberX(newOption);

        handleOptionClick1(option, step + "." + iron + shotoption)
    };

    const handleOptionStrickX = (option, shotoption, shot) => {
        const newOption = { ...option, shot: shot };
        setSelectedNUmberY(newOption);

        handleOptionClick1(option, step + "." + iron + shotoption);
    };

    const [selectedOption, setSelectedOption] = useState(
        remotefittingdata?.[step]?.[iron]?.shot1?.option1 || ''
    );

    // Event handler for when an option is selected
    const handleOptionChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedOption(selectedValue);
        handleOptionClick1({ text: selectedValue }, `${step}.${iron}.shot1.option1`);
    };

    return (
        <>
            <div className="new-design-border-sec">
                <div className="sec-header-dash border-header-sec new-design-header white">
                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                        <h3 className="box-title-lable">
                            <span className="color">{number}</span> {title}
                        </h3>
                    </div>
                    <div className="content-box-btn">
                        <div className={`head_check ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option1 && remotefittingdata[step][iron].shot1.option2 && remotefittingdata[step][iron].shot2.option1 && remotefittingdata[step][iron].shot2.option2 && remotefittingdata[step][iron].shot3.option1 && remotefittingdata[step][iron].shot3.option2 ? 'active' : ''}`}>
                            <FaCheck />
                        </div>
                    </div>
                </div>

                <div className={`form-box-color custom-select-container  p-0 ${dropdownState.isOpen1 ? 'open' : ''}`}>
                    <label className="dashboard-form-lable new-design-label">Shot 1</label>
                    <div className="arrow_svg_image">
                        <div className='svg-image-design mb-5'>
                            <StickSvg color={title} shot={1} level={iron} selectedNUmberX={selectedNUmberX} selectedNUmberY={selectedNUmberY} step={step} />
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Strike</label>
                        <div className="w-60">
                            <div className='drop-down-wrapper d-flex gap-3'>
                                {/* <div className={`custom-select-wrapper w-50 ${dropdownState.isOpenx ? 'open' : ''}`} onClick={() => handleToggleDropdown('isOpenx')}>
                                    <div className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.optionx ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{remotefittingdata[step][iron].shot1.optionx ? remotefittingdata[step][iron].shot1.optionx : <FaArrowsAltH />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                    {dropdownState.isOpenx && (
                                        <div className='options-list'>
                                            {options2.map(option => (
                                                <div
                                                    key={option.id}
                                                    className={`option ${remotefittingdata[step][iron].shot1.optionx && remotefittingdata[step][iron].shot1.optionx === option.text ? 'selected' : ''}`}
                                                    onClick={() => handleOptionStrickY(option, ".shot1.optionx", 1)}
                                                >
                                                    <div className="custom-option-label">
                                                        <span className="option-text">{option.text}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> */}

                                <Form.Select
                                    aria-label="Shot Shape Select Menu"
                                    // value={remotefittingdata[step][iron].shot1.optionx ? remotefittingdata[step][iron].shot1.optionx : 'Shot Shape'}
                                    value={remotefittingdata[step][iron].shot1.optionx || ''}
                                    onChange={(e) => {
                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                        const obj = { id: dataId, text: e.target.value }
                                        handleOptionStrickY(obj, ".shot1.optionx", 1)
                                    }}

                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.optionx ? 'selected' : ''}`}
                                    open={true}
                                >
                                    <option value="" disabled>
                                        <span className='new-icon-select-box'>↔</span>
                                    </option>
                                    {options2.map((option) => (
                                        <option key={option.id} value={option.text} data-id={option.id}
                                        >
                                            {option.text}

                                        </option>
                                    ))}
                                </Form.Select>

                                {/* <div className={`custom-select-wrapper w-50 ${dropdownState.isOpeny ? 'open' : ''}`} onClick={() => handleToggleDropdown('isOpeny')}>
                                    <div className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.optiony ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{remotefittingdata[step][iron].shot1.optiony ? remotefittingdata[step][iron].shot1.optiony : <FaArrowsAltV />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                    {dropdownState.isOpeny && (
                                        <div className='options-list'>
                                            {options2.map(option => (
                                                <div className={`custom-option-label ${remotefittingdata[step][iron].shot1.option1 && remotefittingdata[step][iron].shot1.optiony === option.text ? 'selected' : ''}`} key={option.id} onClick={() => handleOptionStrickX(option, ".shot1.optiony", 1)}>
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> */}
                                <Form.Select
                                    aria-label="Shot Shape Select Menu"
                                    // value={remotefittingdata[step][iron].shot1.optiony ? remotefittingdata[step][iron].shot1.optiony : 'Shot Shape'}
                                    value={remotefittingdata[step][iron].shot1.optiony || ''}
                                    onChange={(e) => {
                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                        const obj = { id: dataId, text: e.target.value }
                                        handleOptionStrickX(obj, ".shot1.optiony", 1)
                                    }}

                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx new-icon-select-box-2 ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.optiony ? 'selected' : ''}`}
                                    open={true}
                                >
                                    <option value="" disabled>
                                        <span className='new-icon-select-box'>↕</span>
                                    </option>
                                    {options2.map((option) => (
                                        <option key={option.id} value={option.text} data-id={option.id}
                                        >
                                            {option.text}

                                        </option>
                                    ))}
                                </Form.Select>
                            </div>

                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Shape</label>
                        <div className="w-60">

                            <Form.Select
                                aria-label="Shot Shape Select Menu"
                                // value={remotefittingdata[step][iron].shot1.option1 ? remotefittingdata[step][iron].shot1.option1 : 'Shot Shape'}
                                value={remotefittingdata[step][iron].shot1.option1 || ''}
                                onChange={(e) => {
                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                    const obj = { id: dataId, text: e.target.value }
                                    handleOptionClick1(obj, step + "." + iron + ".shot1.option1")
                                }}

                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option1 ? 'selected' : ''}`}
                                open={true}
                            >
                                <option value="" disabled>Shot Shape</option>
                                {options.map((option) => (
                                    <option key={option.id} value={option.text} data-id={option.id}
                                    >
                                        {option.text}

                                    </option>
                                ))}
                            </Form.Select>


                            {/* <div className={`custom-select-wrapper w-100 ${dropdownState.isOpen1 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option1 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown('isOpen1')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot1.option1 ? remotefittingdata[step][iron].shot1.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState.isOpen1 && (
                                    <div className="options-list">
                                        {options.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot1.option1 && remotefittingdata[step][iron].shot1.option1 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClick1(option, step + "." + iron + ".shot1.option1")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                        </div>
                    </div>

                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Result</label>
                        <div className="w-60">
                            <Form.Select
                                aria-label="Shot Result Select Menu"
                                value={remotefittingdata[step][iron].shot1.option2 ? remotefittingdata[step][iron].shot1.option2 : ''}
                                onChange={(e) => {
                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                    const obj = { id: dataId, text: e.target.value }
                                    handleOptionClickResult(obj, step + "." + iron + ".shot1.option2")
                                }}
                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option2 ? 'selected' : ''}`}
                            >

                                <option value="" disabled>Shot Result</option>
                                {shotOpction.map((option) => (
                                    <option key={option.id} value={option.text} data-id={option.id}
                                    >
                                        {option.text}

                                    </option>
                                ))}
                            </Form.Select>
                            {/* <div className={`custom-select-wrapper w-100 ${dropdownState.isOpen2 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot1 && remotefittingdata[step][iron].shot1.option2 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown('isOpen2')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot1.option2 ? remotefittingdata[step][iron].shot1.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState.isOpen2 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState.isOpen2 && (
                                    <div className="options-list">
                                        {shotOpction.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot1.option2 && remotefittingdata[step][iron].shot1.option2 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClickResult(option, step + "." + iron + ".shot1.option2")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className={`form-box-color custom-select-container  p-0 ${dropdownState2.isOpen1 ? 'open' : ''}`}>
                    <label className="dashboard-form-lable new-design-label">Shot 2</label>
                    <div className="arrow_svg_image">
                        <div className='svg-image-design mb-5'>
                            <StickSvg color={title} shot={2} level={iron} selectedNUmberX={selectedNUmberX} selectedNUmberY={selectedNUmberY} step={step} />
                        </div>
                    </div>

                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Strike</label>
                        <div className="w-60">
                            <div className='drop-down-wrapper d-flex gap-3'>


                                <Form.Select
                                    aria-label="Shot Shape Select Menu"
                                    // value={remotefittingdata[step][iron].shot2.optionx ? remotefittingdata[step][iron].shot2.optionx : 'Shot Shape'}
                                    value={remotefittingdata[step][iron].shot2.optionx || ''}
                                    onChange={(e) => {
                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                        const obj = { id: dataId, text: e.target.value }
                                        handleOptionStrickY(obj, ".shot2.optionx", 2)
                                    }}

                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.optionx ? 'selected' : ''}`}
                                    open={true}
                                >
                                    <option value='' disabled>
                                        <span className='new-icon-select-box'>↔</span>
                                    </option>
                                    {options2.map((option) => (
                                        <option key={option.id} value={option.text} data-id={option.id}
                                        >
                                            {option.text}

                                        </option>
                                    ))}
                                </Form.Select>


                                {/* <div className={`custom-select-wrapper w-50 ${dropdownState2.isOpenx ? 'open' : ''}`} onClick={() => handleToggleDropdown2('isOpenx')}>
                                    <div className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.optionx ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{remotefittingdata[step][iron].shot2.optionx ? remotefittingdata[step][iron].shot2.optionx : <FaArrowsAltH />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState2.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                    {dropdownState2.isOpenx && (
                                        <div className='options-list'>
                                            {options2.map(option => (
                                                <div
                                                    key={option.id}
                                                    className={`option ${remotefittingdata[step][iron].shot2.optionx && remotefittingdata[step][iron].shot2.optionx === option.text ? 'selected' : ''}`}
                                                    onClick={() => handleOptionStrickY(option, ".shot2.optionx", 2)}
                                                >
                                                    <div className="custom-option-label">
                                                        <span className="option-text">{option.text}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> */}

                                <Form.Select
                                    aria-label="Shot Shape Select Menu"
                                    // value={remotefittingdata[step][iron].shot2.optiony ? remotefittingdata[step][iron].shot2.optiony : 'Shot Shape'}
                                    value={remotefittingdata[step][iron].shot2.optiony || ''}
                                    onChange={(e) => {
                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                        const obj = { id: dataId, text: e.target.value }
                                        handleOptionStrickX(obj, ".shot2.optiony", 2)
                                    }}

                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.optiony ? 'selected' : ''}`}
                                    open={true}
                                >
                                    <option value="" disabled>
                                        <span className='new-icon-select-box'>↕</span>
                                    </option>
                                    {options2.map((option) => (
                                        <option key={option.id} value={option.text} data-id={option.id}
                                        >
                                            {option.text}

                                        </option>
                                    ))}
                                </Form.Select>


                                {/* <div className={`custom-select-wrapper w-50 ${dropdownState2.isOpeny ? 'open' : ''}`} onClick={() => handleToggleDropdown2('isOpeny')}>
                                    <div className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.optiony ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{remotefittingdata[step][iron].shot2.optiony ? remotefittingdata[step][iron].shot2.optiony : <FaArrowsAltV />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState2.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                    {dropdownState2.isOpeny && (
                                        <div className='options-list'>
                                            {options2.map(option => (
                                                <div className={`custom-option-label ${remotefittingdata[step][iron].shot2.optiony && remotefittingdata[step][iron].shot2.optiony === option.text ? 'selected' : ''}`} key={option.id} onClick={() => handleOptionStrickX(option, ".shot2.optiony", 2)}>
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Shape</label>
                        <div className="w-60">

                            {/* <div className={`custom-select-wrapper w-100 ${dropdownState2.isOpen1 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option1 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown2('isOpen1')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot2.option1 ? remotefittingdata[step][iron].shot2.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState2.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState2.isOpen1 && (
                                    <div className="options-list">
                                        {options.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot2.option1 && remotefittingdata[step][iron].shot2.option1 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClick1(option, step + "." + iron + ".shot2.option1")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}


                            <Form.Select
                                aria-label="Shot Result Select Menu"
                                value={remotefittingdata[step][iron].shot2.option1 ? remotefittingdata[step][iron].shot2.option1 : ''}
                                onChange={(e) => {
                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                    const obj = { id: dataId, text: e.target.value }
                                    handleOptionClick1(obj, step + "." + iron + ".shot2.option1")
                                }}
                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option1 ? 'selected' : ''}`}
                            >
                                <option value='' disabled>Shot Shape</option>
                                {options.map((option) => (
                                    <option key={option.id} value={option.text} data-id={option.id}
                                    >
                                        {option.text}

                                    </option>
                                ))}
                            </Form.Select>

                        </div>
                    </div>

                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Result</label>
                        <div className="w-60">

                            {/* <div className={`custom-select-wrapper w-100 ${dropdownState2.isOpen2 ? 'open' : ''}`}>
                                <div
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option2 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown2('isOpen2')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot2.option2 ? remotefittingdata[step][iron].shot2.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState2.isOpen2 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState2.isOpen2 && (
                                    <div className="options-list">
                                        {shotOpction.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot2.option2 && remotefittingdata[step][iron].shot2.option2 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClickResult(option, step + "." + iron + ".shot2.option2")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                            <Form.Select
                                aria-label="Shot Result Select Menu"
                                value={remotefittingdata[step][iron].shot2.option2 ? remotefittingdata[step][iron].shot2.option2 : ''}
                                onChange={(e) => {
                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                    const obj = { id: dataId, text: e.target.value }
                                    handleOptionClickResult(obj, step + "." + iron + ".shot2.option2")
                                }}
                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot2 && remotefittingdata[step][iron].shot2.option2 ? 'selected' : ''}`}
                            >
                                <option value='' disabled>Shot Result</option>
                                {shotOpction.map((option) => (
                                    <option key={option.id} value={option.text} data-id={option.id}
                                    >
                                        {option.text}

                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                </div>

                <div className={`form-box-color custom-select-container  p-0 ${dropdownState3.isOpen1 ? 'open' : ''}`}>
                    <label className="dashboard-form-lable new-design-label">Shot 3</label>
                    <div className="arrow_svg_image">
                        <div className='svg-image-design mb-5'>
                            <StickSvg color={title} shot={3} level={iron} selectedNUmberX={selectedNUmberX} selectedNUmberY={selectedNUmberY} step={step} />
                        </div>
                    </div>
                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Strike</label>
                        <div className="w-60">
                            <div className='drop-down-wrapper d-flex gap-3'>
                                {/* <div className={`custom-select-wrapper w-50 ${dropdownState3.isOpenx ? 'open' : ''}`} onClick={() => handleToggleDropdown3('isOpenx')}>
                                    <div className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.optionx ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{remotefittingdata[step][iron].shot3.optionx ? remotefittingdata[step][iron].shot3.optionx : <FaArrowsAltH />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState3.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                    {dropdownState3.isOpenx && (
                                        <div className='options-list'>
                                            {options2.map(option => (
                                                <div
                                                    key={option.id}
                                                    className={`option ${remotefittingdata[step][iron].shot3.optionx && remotefittingdata[step][iron].shot3.optionx === option.text ? 'selected' : ''}`}
                                                    onClick={() => handleOptionStrickY(option, ".shot3.optionx", 2)}
                                                >
                                                    <div className="custom-option-label">
                                                        <span className="option-text">{option.text}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> */}

                                <Form.Select
                                    aria-label="Shot Shape Select Menu"
                                    // value={remotefittingdata[step][iron].shot3.optionx ? remotefittingdata[step][iron].shot3.optionx : 'Shot Shape'}
                                    value={remotefittingdata[step][iron].shot3.optionx || ''}
                                    onChange={(e) => {
                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                        const obj = { id: dataId, text: e.target.value }
                                        handleOptionStrickY(obj, ".shot3.optionx", 3)
                                    }}

                                    className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.optionx ? 'selected' : ''}`}
                                    open={true}
                                >
                                    <option value='' disabled>
                                        <span className='new-icon-select-box'>↔</span>
                                    </option>
                                    {options2.map((option) => (
                                        <option key={option.id} value={option.text} data-id={option.id}
                                        >
                                            {option.text}

                                        </option>
                                    ))}
                                </Form.Select>

                                {/* <div className={`custom-select-wrapper w-50 ${dropdownState3.isOpeny ? 'open' : ''}`} onClick={() => handleToggleDropdown3('isOpeny')}>
                                    <div className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.optiony ? 'selected' : ''}`}>
                                        <div className="custom-option-label2">
                                            <span className="option-text">{remotefittingdata[step][iron].shot3.optiony ? remotefittingdata[step][iron].shot3.optiony : <FaArrowsAltV />}</span>
                                        </div>
                                        <i className={`bi ${dropdownState3.isOpenx ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                    </div>
                                    {dropdownState3.isOpeny && (
                                        <div className='options-list'>
                                            {options2.map(option => (
                                                <div className={`custom-option-label ${remotefittingdata[step][iron].shot3.optiony && remotefittingdata[step][iron].shot3.optiony === option.text ? 'selected' : ''}`} key={option.id} onClick={() => handleOptionStrickX(option, ".shot3.optiony", 2)}>
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> */}

                                <Form.Select
                                    aria-label="Shot Shape Select Menu"
                                    // value={remotefittingdata[step][iron].shot3.optiony ? remotefittingdata[step][iron].shot3.optiony : 'Shot Shape'}
                                    value={remotefittingdata[step][iron].shot3.optiony || ''}
                                    onChange={(e) => {
                                        const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                        const obj = { id: dataId, text: e.target.value }
                                        handleOptionStrickX(obj, ".shot3.optiony", 3)
                                    }}

                                    className={`form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.optiony ? 'selected' : ''}`}
                                    open={true}
                                >
                                    <option value="" disabled>
                                        <span className='new-icon-select-box'>↕</span>
                                    </option>
                                    {options2.map((option) => (
                                        <option key={option.id} value={option.text} data-id={option.id}
                                        >
                                            {option.text}

                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    </div>

                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Shape</label>
                        <div className="w-60">
                            <Form.Select
                                aria-label="Shot Result Select Menu"
                                value={remotefittingdata[step][iron].shot3.option1 ? remotefittingdata[step][iron].shot3.option1 : ''}
                                onChange={(e) => {
                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                    const obj = { id: dataId, text: e.target.value }
                                    handleOptionClick1(obj, step + "." + iron + ".shot3.option1")
                                }}
                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option1 ? 'selected' : ''}`}
                            >
                                <option value='' disabled>Shot Shape</option>
                                {options.map((option) => (
                                    <option key={option.id} value={option.text} data-id={option.id}
                                    >
                                        {option.text}

                                    </option>
                                ))}
                            </Form.Select>
                            {/* <div className={`custom-select-wrapper w-100 ${dropdownState3.isOpen1 ? 'open' : ''}`}>
                                <div
                                    // className={`selected-option ${remotefittingdata ? 'selected' : ''}`}
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option1 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown3('isOpen1')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot3.option1 ? remotefittingdata[step][iron].shot3.option1 : 'Shot Shape'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState3.isOpen1 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState3.isOpen1 && (
                                    <div className="options-list">
                                        {options.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot3.option1 && remotefittingdata[step][iron].shot3.option1 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClick1(option, step + "." + iron + ".shot3.option1")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                        </div>
                    </div>

                    <div className="custom-form-group new-design-form-group">
                        <label className="dashboard-form-lable">Shot Result</label>
                        <div className="w-60">
                            {/* <div className={`custom-select-wrapper w-100 ${dropdownState3.isOpen2 ? 'open' : ''}`}>
                                <div
                                    // className={`selected-option ${remotefittingdata ? 'selected' : ''}`}
                                    className={`selected-option ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option2 ? 'selected' : ''}`}
                                    onClick={() => handleToggleDropdown3('isOpen2')}
                                >
                                    <div className="custom-option-label2">
                                        <span className="option-text">
                                            {remotefittingdata[step][iron].shot3.option2 ? remotefittingdata[step][iron].shot3.option2 : 'Shot Result'}
                                        </span>
                                    </div>
                                    <i className={`bi ${dropdownState3.isOpen2 ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                                </div>
                                {dropdownState3.isOpen2 && (
                                    <div className="options-list">
                                        {shotOpction.map((option) => (
                                            <div
                                                key={option.id}
                                                className={`option ${remotefittingdata[step][iron].shot3.option2 && remotefittingdata[step][iron].shot3.option2 === option.text ? 'selected' : ''}`}
                                                onClick={() => handleOptionClickResult(option, step + "." + iron + ".shot3.option2")}
                                            >
                                                <div className="custom-option-label">
                                                    <span className="option-text">{option.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                            <Form.Select
                                aria-label="Shot Result Select Menu"
                                value={remotefittingdata[step][iron].shot3.option2 ? remotefittingdata[step][iron].shot3.option2 : 'Shot Result'}
                                onChange={(e) => {
                                    const dataId = e.target.selectedOptions[0].getAttribute('data-id');
                                    const obj = { id: dataId, text: e.target.value }
                                    handleOptionClickResult(obj, step + "." + iron + ".shot3.option2")
                                }}
                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${remotefittingdata && remotefittingdata[step] && remotefittingdata[step][iron] && remotefittingdata[step][iron].shot3 && remotefittingdata[step][iron].shot3.option2 ? 'selected' : ''}`}
                            >
                                <option value='' disabled>Shot Result</option>
                                {shotOpction.map((option) => (
                                    <option key={option.id} value={option.text} data-id={option.id}
                                    >
                                        {option.text}

                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default IronsData;
